import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from '../../../lib/axios';

function ParentSettings() {
    const userOnline = useSelector((state) => state.auth.user);
    const [genres, setGenres] = useState([]);

    const user = {
        nombre: userOnline.nombre,
        email: userOnline.email,
        sexoId: userOnline.sexoId,
        fechaNacimiento: userOnline.fechaNacimiento,
    }

    const fetchGenres = async () => {
        try {
            const response = await axios.get('/Sex');
            setGenres(response.data.data);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        fetchGenres();
    }, []);

    return (
        <div className='my-3'>
            <form class="grid grid-cols-1 md:grid-cols-2 gap-4 w-full md:w-3/4">   
                <div className="relative">
                    <p for="nombrePadre" className='mb-2 text-sm'>Father's Name</p>
                    <input id="nombrePadre" type="text" value={user.nombre} 
                        className="bg-white border-[#C7DDDA] border-[2px] text-gray-900 text-sm block w-full p-3 rounded-[16px] px-4 focus:outline-none focus:ring-1 focus:ring-[#C7DDDA]" 
                        placeholder="Father's Name" required 
                        onChange={(e) => { user.nombre = e.target.value; }}
                    />
                </div>
                <div className="relative">
                    <p for="correoPadre" className='mb-2 text-sm'>Email</p>
                    <input id="correoPadre" type="email"  value={user.email}
                        className="bg-white border-[#C7DDDA] border-[2px] text-gray-900 text-sm block w-full p-3 rounded-[16px] px-4 focus:outline-none focus:ring-1 focus:ring-[#C7DDDA]" 
                        placeholder="Email" required 
                        onChange={(e) => { user.email = e.target.value; }}
                    />
                </div>
                <div className="relative">
                    <p for="Relationship" className='mb-2 text-sm'>Relationship</p>
                    <select id="parentesco" type="text" 
                        value={user.sexoId}
                        className="bg-white border-[#C7DDDA] border-[2px] text-gray-900 text-sm block w-full p-3 rounded-[16px] px-4 focus:outline-none focus:ring-1 focus:ring-[#C7DDDA]" 
                        placeholder="Seleccione parentesco..." required onChange={(e) => {user.sexoId = e.target.value; }}>
                        { (genres) && genres.map((genre) => (
                            <option key={genre.sexoId} value={genre.sexoId}>{genre.descripcion}</option>
                        ))}
                    </select>
                </div>
                <div className="relative">
                    <p for="nombrePadre" className='mb-2 text-sm'>Birthdate</p>
                    <input id="nombrePadre" type="date" 
                        value={user.fechaNacimiento}
                        className="bg-white border-[#C7DDDA] border-[2px] text-gray-900 text-sm block w-full p-3 rounded-[16px] px-4 focus:outline-none focus:ring-1 focus:ring-[#C7DDDA]" 
                        placeholder="Birthdate" required 
                        onChange={(e) => { user.fechaNacimiento = e.target.value; }}
                    />
                </div>
                <button type='submit' className="rounded-lg p-3 bg-[#90BCB5] w-1/3">
                    <span className="text-white text-base font-medium">Save</span>
                </button>
            </form>
        </div>
    );
}

export default ParentSettings;